import React, { Component } from "react";
import PresentSettings from "../../../components/settings/slideshow/PresentSettings";
import defaultFases from "../../../constants/DefaultFases";
import { getRankingPerDivision } from "../../../util/GetRankingPerDivision";
import { languages } from "../../../constants/languages";

class PresentSettingsContainer extends Component {
  state = {
    dias: [],
    diasByKey: {},
    diasLoaded: false,
    poules: [],
    poulesAll: [],
    poulesByKey: {},
    poulesLoaded: false,
    brackets: [],
    bracketsByKey: {},
    bracketsLoaded: false,
    selectedSlideshow: "0",
    slideshows: [],
    slideshowsByKey: {},
    slideshowsLoaded: false,
    days: [],
    daysByKey: {},
    daysLoaded: false,
    sportParks: [],
    sportParksByKey: {},
    sportParksLoaded: false,
    teams: [],
    teamsByKey: {},
    teamsLoaded: false,
    players: [],
    playersLoaded: false,
    matches: [],
    matchesLoaded: false,
    resultSpotsAll: [],
    resultSpotsLoaded: false,
    diasTemp: undefined,

    isDraggingWithinDia: null,
  };

  setDraggingWithinDia = (diaId) => {
    this.setState({ isDraggingWithinDia: diaId });
  };

  selectSlideshow = (slideshowId) => {
    this.setState({ selectedSlideshow: slideshowId });
  };

  handleAddSlideshow = () => {
    let slideshowId = "1";
    if (this.state.slideshows.length > 0) {
      slideshowId = (
        Number(this.state.slideshows[this.state.slideshows.length - 1].id) + 1
      ).toString();
    }
    const db = window.firebase.firestore();
    let batch = db.batch();

    batch.set(
      db
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("slideshows")
        .doc(slideshowId),
      {}
    );

    if ((this.props.userData || {}).isPSD || this.props.tournament.crqpsd) {
      let photoURLS = {
        en: "https://firebasestorage.googleapis.com/v0/b/tournament-uploads/o/slide-en.png?alt=media&token=ea2773d2-1dbc-4fd2-913d-b851d1bef490",
        nl: "https://firebasestorage.googleapis.com/v0/b/tournament-uploads/o/slide-nl.png?alt=media&token=00e7ca24-3eb9-439d-9096-46fe792d68ac",
        fr: "https://firebasestorage.googleapis.com/v0/b/tournament-uploads/o/slide-fr.png?alt=media&token=5c423efe-6aaa-43f2-b692-9439b20a8203",
      };

      let photoURL = this.props.tournament.crqpsd
        ? photoURLS.en
        : photoURLS[languages.getLanguage()] || photoURLS.en;

      let diaDoc = db
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("dias")
        .doc();
      batch.set(diaDoc, {
        isPSD: true,
        diaPhotoIndex: 0,
        diaPhotoTitle: "",
        diaPhotoURL: photoURL,
        slideshow: slideshowId,
        sponsorIndex: null,
        diaText: null,
        diaTextIndex: null,
        active: true,
        time: 5,
        day: null,
        num: 0,
      });
    }

    batch.commit();
  };

  UNSAFE_componentWillMount = () => {
    this.unsubscribe = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("dias")
      .orderBy("num")
      .onSnapshot((querySnapshot) => {
        var dias = [];
        let diasByKey = {};
        querySnapshot.forEach(function (doc) {
          let dia = doc.data();
          dia.id = doc.id;
          dias.push(dia);
          diasByKey[doc.id] = doc.data();
        });
        this.setState({
          dias: dias,
          diasByKey: diasByKey,
          diasLoaded: true,
          diasTemp: undefined,
        });
      });

    this.unsubscribe2 = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("slideshows")
      .onSnapshot((querySnapshot) => {
        var slideshows = [];
        let slideshowsByKey = {};
        querySnapshot.forEach(function (doc) {
          let slideshow = doc.data();
          slideshow.id = doc.id;
          slideshows.push(slideshow);
          slideshowsByKey[doc.id] = doc.data();
        });
        this.setState({
          slideshows: slideshows,
          slideshowsByKey: slideshowsByKey,
          slideshowsLoaded: true,
        });
      });

    this.unsubscribePoules = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("poules")
      .onSnapshot((querySnapshot) => {
        let poules = [];
        let poulesAll = [];
        let poulesByKey = {};
        querySnapshot.forEach((doc) => {
          let poule = doc.data();
          let division = this.props.divisionsObject[poule.division];

          // If division is not found, it means the poule is not valid anymore, so we skip it
          if (!division) {
            return;
          }

          poule["id"] = doc.id;
          poule["value"] = doc.id;
          poule["label"] =
            poule.name +
            " - " +
            ((division.fases || defaultFases)[poule.fase] || {}).name;
          if (this.props.divisions.length > 1) {
            poule["label"] = poule.label + " - " + division.name;
          }
          if (!poule.bracket) {
            poules.push(poule);
          }
          poulesAll.push(poule);

          poulesByKey[doc.id] = poule;
        });
        // poules.sort((a, b) => a.num - b.num);
        this.setState({
          poules: poules,
          poulesAll: poulesAll,
          poulesByKey: poulesByKey,
          poulesLoaded: true,
        });
      });

    this.unsubscribeBrackets = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("brackets")
      .onSnapshot((querySnapshot) => {
        let brackets = [];
        let bracketsByKey = {};
        querySnapshot.forEach((doc) => {
          let bracket = doc.data();
          let division = this.props.divisionsObject[bracket.division];
          bracket["isBracket"] = true;
          bracket["id"] = doc.id;
          bracket["label"] =
            bracket.name +
            " - " +
            ((division.fases || defaultFases)[bracket.fase] || {}).name;
          if (this.props.divisions.length > 1) {
            bracket["label"] = bracket.label + " - " + division.name;
          }
          brackets.push(bracket);
          bracketsByKey[doc.id] = bracket;
        });
        // brackets.sort((a, b) => a.num - b.num);
        this.setState({
          brackets: brackets,
          bracketsByKey: bracketsByKey,
          bracketsLoaded: true,
        });
      });

    this.unsubscribeDays = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("days")
      .onSnapshot((querySnapshot) => {
        let days = [];
        let daysObj = {};
        querySnapshot.forEach((doc) => {
          let day = doc.data();
          day["id"] = doc.id;
          days.push(day);
          daysObj[doc.id] = doc.data();
        });
        this.setState({
          days: days.sort((a, b) => a.date - b.date),
          daysByKey: daysObj,
          daysLoaded: true,
        });
      });

    this.unsubscribeSportparks = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("sportParks")
      .onSnapshot((querySnapshot) => {
        let sportParks = [];
        let sportParksObj = {};
        querySnapshot.forEach((doc) => {
          let sportPark = doc.data();
          sportPark["id"] = doc.id;
          sportParks.push(sportPark);
          sportParksObj[doc.id] = sportPark;
        });
        let sportParksSorted = sportParks.sort((a, b) => {
          if (a.num > b.num) {
            return 1;
          } else if (a.num < b.num) {
            return -1;
          }
          if (a.id > b.id) {
            return 1;
          } else if (a.id < b.id) {
            return -1;
          } else {
            return 0;
          }
        });
        let newState = {
          sportParks: sportParksSorted,
          sportParksByKey: sportParksObj,
          sportParksLoaded: true,
        };

        this.setState(newState);
      });

    this.unsubscribeTeams = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("teams")
      .onSnapshot((querySnapshot) => {
        let teams = [];
        let teamsByKey = {};
        querySnapshot.forEach((doc) => {
          let team = doc.data();
          team["id"] = doc.id;
          teams.push(team);
          teamsByKey[doc.id] = team;
        });
        this.setState({
          teams: teams,
          teamsByKey: teamsByKey,
          teamsLoaded: true,
        });
      });

    this.unsubscribePlayers = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("players")
      .onSnapshot((querySnapshot) => {
        let players = [];
        querySnapshot.forEach((doc) => {
          let player = doc.data();
          player["id"] = doc.id;
          players.push(player);
        });
        this.setState({
          players: players,
          playersLoaded: true,
        });
      });

    this.unsubscribeMatches = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("matches")
      .onSnapshot((querySnapshot) => {
        let matches = [];
        let matchesByKey = {};
        querySnapshot.forEach(function (doc) {
          let match = doc.data();
          if (match.day === undefined) {
            match["day"] = "0";
          }
          match["id"] = doc.id;
          matches.push(match);
          matchesByKey[doc.id] = match;
        });
        let newState = {};
        newState["matches"] = matches;
        newState["matchesLoaded"] = true;
        this.setState(newState);
      });

    this.unsubscribeResultSpots = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("resultSpots")
      .onSnapshot((querySnapshot) => {
        let resultSpotsAll = [];
        let resultSpotsByKey = {};
        querySnapshot.forEach((doc) => {
          let resultSpot = doc.data();
          resultSpot["id"] = doc.id;
          resultSpot["resultSpot"] = true;
          resultSpotsAll.push(resultSpot);
          resultSpotsByKey[doc.id] = resultSpot;
        });
        this.setState({
          resultSpotsLoaded: true,
          resultSpotsAll: resultSpotsAll,
        });
      });
  };

  componentWillUnmount = () => {
    // unsubscribe
    this.unsubscribe();
    this.unsubscribe2();
    this.unsubscribePoules();
    this.unsubscribeBrackets();
    this.unsubscribeDays();
    this.unsubscribeSportparks();
    this.unsubscribeTeams();
    this.unsubscribePlayers();
    this.unsubscribeMatches();
    this.unsubscribeResultSpots();
  };

  handleAddSponsors = (
    e,
    diaId,
    structureElements,
    sponsorGroup = undefined
  ) => {
    e.preventDefault();

    let numInDia = 0;
    let sponsorNum = "";
    if (structureElements.length > 0) {
      numInDia =
        (structureElements[structureElements.length - 1] || {}).numInDia + 1;
    }

    const dia = this.state.diasByKey[diaId];
    ["", "1", "2", "3", "4", "5", "6", "7", "8"].reverse().forEach((x) => {
      if (
        dia["sponsorIndex" + x] === null ||
        dia["sponsorIndex" + x] === undefined
      ) {
        sponsorNum = x;
      }
    });

    let toUpdate = {};
    toUpdate["sponsorIndex" + sponsorNum] = numInDia;
    toUpdate["sponsorGroup" + sponsorNum] = sponsorGroup;

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("dias")
      .doc(diaId)
      .update(toUpdate);
  };

  handleTeamLayoutsSortChange = (e) => {
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update({ teamLayoutsSort: e.target.value });
  };

  handleAddQRCode = (e, diaId, structureElements) => {
    e.preventDefault();

    let numInDia = 0;
    if (structureElements.length > 0) {
      numInDia =
        (structureElements[structureElements.length - 1] || {}).numInDia + 1;
    }

    let toUpdate = { qrCodeIndex: numInDia };

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("dias")
      .doc(diaId)
      .update(toUpdate);
  };

  handleActiveCheck = (e, diaId) => {
    let checked = e.target.checked;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("dias")
      .doc(diaId)
      .update({ active: checked });
  };

  handleShowChange = (e) => {
    let toUpdate = {};
    if (this.props.tournament[e.target.name] === undefined) {
      toUpdate[e.target.name] = false;
    } else {
      toUpdate[e.target.name] = !this.props.tournament[e.target.name];
    }
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const dias = this.state.dias
      .filter((dia) => {
        let showDia = false;
        if (this.state.selectedSlideshow === "0") {
          if (dia.slideshow === undefined || dia.slideshow === "0") {
            showDia = true;
          }
        } else {
          if (dia.slideshow === this.state.selectedSlideshow) {
            showDia = true;
          }
        }
        return showDia;
      })
      .slice();
    const [removed] = dias.splice(result.source.index, 1);
    dias.splice(result.destination.index, 0, removed);

    const db = window.firebase.firestore();
    let batch = db.batch();
    const diasRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("dias");

    let diasTemp = [];

    dias.forEach((l, i) => {
      let dia = dias[i];
      dia["num"] = i;
      diasTemp.push(dia);
      batch.update(diasRef.doc(l.id), { num: i });
    });

    this.setState({
      diasTemp: diasTemp,
    });
    batch.commit().catch((error) => {
      console.log(error.message);
      this.setState({ diasTemp: undefined });
    });
  };

  render() {
    let toRender = null;

    if (
      this.state.diasLoaded &&
      this.state.poulesLoaded &&
      this.state.bracketsLoaded &&
      this.state.slideshowsLoaded &&
      this.state.daysLoaded &&
      this.state.teamsLoaded &&
      this.state.playersLoaded &&
      this.state.matchesLoaded &&
      this.state.resultSpotsLoaded
    ) {
      let ranking = getRankingPerDivision(
        this.props.divisions,
        this.state.poulesAll,
        this.state.brackets,
        this.state.resultSpotsAll,
        this.props.tournament,
        this.state.matches,
        this.state.teams
      );

      let fontSize =
        (this.state.slideshowsByKey[this.state.selectedSlideshow] || {})
          .slideshowFontSize || "1";
      if (this.state.selectedSlideshow === "0") {
        fontSize = this.props.tournament.slideshowFontSize || "1";
      }

      let allStructureElements = this.state.poules.concat(this.state.brackets);
      // let structureElementsNotDivided = [];
      let structureElementsPerDia = {};
      for (let i in allStructureElements) {
        for (let x = 0; x < 100; x++) {
          let structureElement = { ...allStructureElements.slice()[i] };
          let diaKeyName = "dia";
          if (x > 0) {
            diaKeyName += x.toString();
            structureElement["diaNum"] = x;
          }
          structureElement["numInDiaLocal"] =
            structureElement["numInDia" + (x > 0 ? x.toString() : "")];

          if (
            structureElement[diaKeyName] &&
            this.state.diasByKey[structureElement[diaKeyName]]
          ) {
            if (
              structureElementsPerDia[structureElement[diaKeyName]] ===
              undefined
            ) {
              structureElementsPerDia[structureElement[diaKeyName]] = [];
            }
            if (structureElement.isBracket && structureElement.size > 16) {
              let bracketRound =
                structureElement[
                  "bracketRoundDia" + (x > 0 ? x.toString() : "")
                ] || 16;
              structureElement["label"] +=
                " - " +
                languages.schedule.round +
                " " +
                bracketRound.toString();

              let numParts = 1;
              if (
                bracketRound === 32 &&
                (fontSize === "2" || fontSize === "3")
              ) {
                numParts = 2;
              }
              if (bracketRound === 64) {
                numParts = 2;
                if (fontSize === "2" || fontSize === "3") {
                  numParts = 4;
                }
              }

              let bracketRoundPart =
                structureElement[
                  "bracketRoundPartDia" + (x > 0 ? x.toString() : "")
                ];
              if (
                bracketRoundPart === undefined ||
                bracketRoundPart + 1 > numParts
              ) {
                bracketRoundPart = 0;
              }
              if (
                bracketRoundPart !== undefined &&
                numParts > 1 &&
                bracketRound > 16
              ) {
                structureElement["label"] +=
                  " (" +
                  (bracketRoundPart + 1).toString() +
                  "/" +
                  numParts.toString() +
                  ")";
              }
            }

            structureElementsPerDia[structureElement[diaKeyName]].push(
              structureElement
            );
          }
        }
      }
      let structureElementsNotDivided = [];

      allStructureElements.forEach((el) => {
        if (el.isBracket) {
          if (el.size === 32) {
            let numParts32 = 1;
            if (fontSize === "2" || fontSize === "3") {
              numParts32 = 2;
            }
            for (let x = 0; x < numParts32; x++) {
              let elCopy = { ...el };
              elCopy["roundLocal"] = 32;
              elCopy["roundPartLocal"] = x;
              elCopy["numPartsLocal"] = numParts32;

              structureElementsNotDivided.push(elCopy);
            }

            el["roundLocal"] = 16;
          }
          if (el.size === 64) {
            let numParts32 = 1;
            if (fontSize === "2" || fontSize === "3") {
              numParts32 = 2;
            }
            let numParts64 = 2;
            if (fontSize === "2" || fontSize === "3") {
              numParts64 = 4;
            }
            for (let x = 0; x < numParts64; x++) {
              let elCopy2 = { ...el };
              elCopy2["roundLocal"] = 64;
              elCopy2["roundPartLocal"] = x;
              elCopy2["numPartsLocal"] = numParts64;

              structureElementsNotDivided.push(elCopy2);
            }
            for (let x = 0; x < numParts32; x++) {
              let elCopy = { ...el };
              elCopy["roundLocal"] = 32;
              elCopy["roundPartLocal"] = x;
              elCopy["numPartsLocal"] = numParts32;
              structureElementsNotDivided.push(elCopy);
            }

            el["roundLocal"] = 16;
          }
        }
        structureElementsNotDivided.push(el);
      });

      structureElementsNotDivided.sort((a, b) => {
        let numDiasA = 0;
        let numDiasB = 0;
        let diaKeyName = "dia";

        for (let x = 0; x < 100; x++) {
          if (
            this.state.diasByKey[a[diaKeyName + (x > 0 ? x.toString() : "")]]
          ) {
            numDiasA++;
          }
          if (
            this.state.diasByKey[b[diaKeyName + (x > 0 ? x.toString() : "")]]
          ) {
            numDiasB++;
          }
        }
        if (numDiasA < numDiasB) {
          return -1;
        } else if (numDiasA > numDiasB) {
          return 1;
        } else if (a.division < b.division) {
          return -1;
        } else if (a.division > b.division) {
          return 1;
        } else if (a.fase < b.fase) {
          return -1;
        } else if (a.fase > b.fase) {
          return 1;
        } else if (a.indexNum < b.indexNum) {
          return -1;
        } else if (a.indexNum > b.indexNum) {
          return 1;
        } else if (a.num < b.num) {
          return -1;
        } else if (a.num > b.num) {
          return 1;
        } else {
          return 0;
        }
      });
      let dias = (this.state.diasTemp ? this.state.diasTemp : this.state.dias)
        .filter((dia) => {
          let showDia = false;
          if (this.state.selectedSlideshow === "0") {
            if (dia.slideshow === undefined || dia.slideshow === "0") {
              showDia = true;
            }
          } else {
            if (dia.slideshow === this.state.selectedSlideshow) {
              showDia = true;
            }
          }
          return showDia;
        })
        .sort((a, b) => {
          if (a.num > b.num) {
            return 1;
          } else if (a.num < b.num) {
            return -1;
          } else {
            return 0;
          }
        });
      toRender = (
        <PresentSettings
          tournament={this.props.tournament}
          dias={dias}
          allDias={this.state.dias}
          poules={this.state.poules}
          brackets={this.state.brackets}
          structureElementsNotDivided={structureElementsNotDivided}
          structureElementsPerDia={structureElementsPerDia}
          handleAddSponsors={this.handleAddSponsors}
          handleActiveCheck={this.handleActiveCheck}
          handleShowChange={this.handleShowChange}
          selectedSlideshow={this.state.selectedSlideshow}
          selectSlideshow={this.selectSlideshow}
          slideshows={this.state.slideshows}
          slideshowsByKey={this.state.slideshowsByKey}
          handleAddSlideshow={this.handleAddSlideshow}
          user={this.props.user}
          userData={this.props.userData}
          userStatus={this.props.userStatus}
          tournamentStatus={this.props.tournamentStatus}
          days={this.state.days}
          daysByKey={this.state.daysByKey}
          teams={this.state.teams}
          teamsByKey={this.state.teamsByKey}
          players={this.state.players}
          onDragEnd={this.onDragEnd}
          divisions={this.props.divisions}
          sportParks={this.state.sportParks}
          ranking={ranking.ranking}
          isDraggingWithinDia={this.state.isDraggingWithinDia}
          setDraggingWithinDia={this.setDraggingWithinDia}
          diasByKey={this.state.diasByKey}
          handleAddQRCode={this.handleAddQRCode}
          handleTeamLayoutsSortChange={this.handleTeamLayoutsSortChange}
        />
      );
    }

    return toRender;
  }
}

export default PresentSettingsContainer;
